import Vue from 'vue'
import Vuex from 'vuex'
// 数据持久化
import persistedState from 'vuex-persistedstate'
// 用户信息模块
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        userInfo: {
            userName: ""
        }, //用户信息
        authorization: null, // token,
    },
    mutations: {
        SET_USERINFO: (state, data) => {
            state.userInfo = data
        },
        SET_AUTHORIZATION: (state, data) => {
            state.authorization = data
        },
    },
    plugins: [persistedState()]
})